import * as PIXI from "pixi.js";

import { Signal } from "signals";
import Button from "../../lib/Button";
import ServiceLocator from "../../ServiceLocator";


export default class ShopItem extends PIXI.Container
{
    //  #region Attributes //

    private _type: shop_item_type = null;
    private _state: shop_item_state = null;
    private _index: number = null;

    private _useButton: Button = null;

    // Signals.
    private _onSelected: Signal = new Signal();

    // #endregion //


    // #region Properties //

    public set type( value: shop_item_type ) { this._type = value; }
    public set state( value: shop_item_state ) { this._state = value; }
    public set index( value: number ) { this._index = value; }

    public get type(): shop_item_type { return this._type; }
    public get state(): shop_item_state { return this._state; }
    public get index(): number { return this._index; }

    // Signals.
    public get onSelected(): Signal { return this._onSelected; }

    // #endregion //


    public init(): void
    {
        console.assert( this._type != null, "ShopItem.ts :: init() :: this._type cannot be null." );
        console.assert( this._state != null, "ShopItem.ts :: init() :: this._state cannot be null." );
        console.assert( this._index != null, "ShopItem.ts :: init() :: this._index cannot be null." );
    
        this.redraw();
    }

    public end(): void
    {
        this._onSelected.dispose();
        this._onSelected = null;
    }

    public update( dt: number ): void {}

    public setEnabled( isEnabled: boolean ): void
    {
        if ( this._useButton )
        {
            this._useButton.setEnabled( isEnabled );
        }
    }

    public redraw(): void
        {
            for ( let child of this.children )
            {
                ( child as PIXI.Container ).destroy( { children: true } );
            }
            this.removeChildren();
                        
            let base: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.shop_product_base.texture );
            this.addChild( base );
    
            let title: PIXI.Text = new PIXI.Text( ServiceLocator.resources.game_config.data[ this._type == shop_item_type.DART ? "darts" : "boards" ][ this._index ].name, {
                fontSize: 30, 
                fontFamily: "jaro_regular", 
                fill: 0x192f62, 
                stroke: 0xffffff, 
                strokeThickness: 8,
                dropShadow: true,
                dropShadowAngle: 2,
                dropShadowColor: "#ffffff",
                dropShadowDistance: 2,
                lineJoin: "round" } );
            title.anchor.set( 0.5 );
            title.position.set( base.texture.width * 0.5, 22 );
            this.addChild( title );
    
            let itemIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ "shop_" + ( this._type == shop_item_type.DART ? "dart" : "board" ) + "_item_" + this._index.toString() ].texture );
            itemIcon.anchor.set( 0.5 );
            itemIcon.position.set( base.texture.width * 0.5, /*this._type == shop_item_type.DART ? 134 :*/ 154 );
            this.addChild( itemIcon );
    
            switch ( this._state )
            {
                case shop_item_state.SELECTED:
                    {
                        let selected: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.shop_product_selected.texture );
                        this.addChild( selected );
    
                        this._useButton = new Button( { on: "shop_button_selected_base"/*, pressed: "shop_button_selected_base_pressed"*/ } );
                        this._useButton.anchor.set( 0.5 );
                        this._useButton.position.set( base.texture.width * 0.5, base.texture.height - 34 );
                        this.addChild( this._useButton );

                        let buttonText: PIXI.Text = new PIXI.Text( "Equipped", {
                            fontSize: 30, 
                            fontFamily: "jaro_regular", 
                            fill: 0x192f62, 
                            stroke: 0xffffff, 
                            strokeThickness: 8,
                            dropShadow: true,
                            dropShadowAngle: 2,
                            dropShadowColor: "#ffffff",
                            dropShadowDistance: 2,
                            lineJoin: "round" } );
                        buttonText.anchor.set( 0.5 );
                        buttonText.y = -4;
                        this._useButton.addChild( buttonText );
    
                        break;
                    }
    
                case shop_item_state.LOCKED:
                    {
                        let disabledFilter: PIXI.Filter = new PIXI.filters.ColorMatrixFilter();
                        ( disabledFilter as any ).greyscale( 0.4, false );
                        itemIcon.filters = [ disabledFilter ];
    
                        let disabled: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.shop_product_locked.texture );
                        disabled.alpha = 0.6;
                        this.addChild( disabled );
    
                        let lockIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.shop_icon_lock.texture );
                        lockIcon.anchor.set( 0.5 );
                        lockIcon.position.set( base.texture.width * 0.5, base.texture.height * 0.5 );
                        this.addChild( lockIcon );
    
                        this._useButton = new Button( { on: "shop_button_lock_base" } );
                        this._useButton.anchor.set( 0.5 );
                        this._useButton.position.set( base.texture.width * 0.5, base.texture.height - 34 );
                        this.addChild( this._useButton );

                        let buttonText: PIXI.Text = new PIXI.Text( "Unlock Lvl." + ServiceLocator.resources.game_config.data[ this._type == shop_item_type.DART ? "darts" : "boards" ][ this._index ].unlockLevel.toString(), {
                            fontSize: 30, 
                            fontFamily: "jaro_regular", 
                            fill: 0x666666, 
                            stroke: 0xffffff, 
                            strokeThickness: 8,
                            dropShadow: true,
                            dropShadowAngle: 2,
                            dropShadowColor: "#ffffff",
                            dropShadowDistance: 2,
                            lineJoin: "round" } );
                        buttonText.anchor.set( 0.5 );
                        buttonText.y = -4;
                        this._useButton.addChild( buttonText );
    
                        break;
                    }
    
                case shop_item_state.UNLOCKED:
                    {
                        if ( this._type == shop_item_type.DART && ServiceLocator.saved.data.isShopDartsUpdated
                            || this._type == shop_item_type.BOARD && ServiceLocator.saved.data.isShopBoardsUpdated )
                        {
                            const kUnlockLevel: number = ServiceLocator.resources.game_config.data[ this._type == shop_item_type.DART ? "darts" : "boards" ][ this._index ].unlockLevel;
                            if ( ServiceLocator.saved.data.level == kUnlockLevel )
                            {
                                let exclamationIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_icon_exclamation.texture );
                                exclamationIcon.scale.set( 44 / exclamationIcon.texture.width );
                                exclamationIcon.anchor.set( 0.5 );
                                exclamationIcon.position.set( base.width - exclamationIcon.width * 0.5 + 4, 0 );
                                this.addChild( exclamationIcon );
                            }
                        }

                        let isAffordable: boolean = ServiceLocator.saved.data.coins >= ServiceLocator.resources.game_config.data[ this._type == shop_item_type.DART ? "darts" : "boards" ][ this._index ].price;
                        if ( isAffordable )
                        {
                            this._useButton = new Button( { on: "shop_button_base" } );
                        }
                        else
                        {
                            this._useButton = new Button( { on: "shop_button_not_enough_money_base"/*, pressed: "shop_button_base_pressed"*/ } );
                        }
                        
                        this._useButton.anchor.set( 0.5 );
                        this._useButton.position.set( base.texture.width * 0.5, base.texture.height - 34 );
                        this.addChild( this._useButton );
    
                        let coinWrapper: PIXI.Container = new PIXI.Container();
                        coinWrapper.position.copyFrom( this._useButton.position );
                        coinWrapper.y -= 4;
                        this.addChild( coinWrapper );
                        //
                        let coinIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.icon_coin.texture );
                        coinIcon.scale.set( 0.5 );
                        coinIcon.anchor.set( 0, 0.5 );
                        coinWrapper.addChild( coinIcon );
                        //
                        let coinBalance: PIXI.Text = new PIXI.Text( ServiceLocator.resources.game_config.data[ this._type == shop_item_type.DART ? "darts" : "boards" ][ this._index ].price.toString(), {
                            fontSize: 40,
                            fontFamily: "jaro_regular", 
                            fill: isAffordable ? 0x192f62 : 0xff0000, 
                            stroke: 0xffffff, 
                            strokeThickness: 4,
                            lineJoin: "round"
                        } );
                        coinBalance.anchor.set( 0, 0.5 );
                        coinBalance.position.set( coinIcon.width + 10, coinIcon.y );
                        coinWrapper.addChild( coinBalance );   
                        //
                        coinWrapper.x -= coinWrapper.width * 0.5;
    
                        break;
                    }
    
                case shop_item_state.OWNED: 
                    {
                        this._useButton = new Button( { on: "shop_button_base"/*, pressed: "shop_button_base_pressed"*/ } );
                        this._useButton.anchor.set( 0.5 );
                        this._useButton.position.set( base.texture.width * 0.5, base.texture.height - 34 );
                        this.addChild( this._useButton );

                        let buttonText: PIXI.Text = new PIXI.Text( "Use", {
                            fontSize: 30, 
                            fontFamily: "jaro_regular", 
                            fill: 0x192f62, 
                            stroke: 0xffffff, 
                            strokeThickness: 8,
                            dropShadow: true,
                            dropShadowAngle: 2,
                            dropShadowColor: "#ffffff",
                            dropShadowDistance: 2,
                            lineJoin: "round" } );
                        buttonText.anchor.set( 0.5 );
                        buttonText.y = -4;
                        this._useButton.addChild( buttonText );

                        break;
                    }
            }
    
            if ( this._useButton )
            {
                this._useButton.on( "pointertap", () => { this._onSelected.dispatch( this ); } );
            }
        }
}

export const enum shop_item_type
{
    DART = 0,
    BOARD
}

export const enum shop_item_state
{
    SELECTED = 0,
    OWNED,
    LOCKED,
    UNLOCKED
}